<div class="center">
  <div class="loader"></div>
  <p>{{ 'waitingRoom.authenticating' | translate }}</p>
</div>
